import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ServiceCategoryService } from '../services/service.category.service';
import { ServiceCategory } from '../models/service.category.model';
import { NotificationService } from '../services/notification.service';
import { LookupService } from '../services/lookup.service';

@Component({
  selector: 'app-service-category-form',
  templateUrl: './service-category-form.component.html'
})
export class ServiceCategoryFormComponent {
  constructor(public service: ServiceCategoryService, public lookupService: LookupService, private notificationService: NotificationService) { }

  @Input() model: ServiceCategory;
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  submitted = false;

  ngOnInit() {
    //this.notificationService.showDatePicker();
  }

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.serviceCategoryID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {

    this.service.post().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.notificationService.notifySuccess();

        this.closeModal.emit(null);
      },
      err => {
        console.log(err);
      }
    )
  }


}

